import ContentRowTitle from './ContentRowTitle';
export default ContentRowTitle;
